<h2 mat-dialog-title>Infos techniques complémentaires <small>retournés par {{ provider }}</small></h2>

<mat-dialog-content>
  <div class="p-4">
    <table class="w-full table-fixed border-collapse border border-gray-400">
      <tbody>
        @for (entry of entries; track entry[0]) {
        <tr>
          <td class="border border-gray-300 p-2 font-semibold">{{ entry[0] }}</td>
          <td class="border border-gray-300 p-2">{{ entry[1] }}</td>
          <td class="border border-gray-300 p-2 text-center" style="width: 75px">
              <button matIconButton matTooltip="Copier la valeur dans le presse-papiers" [cdkCopyToClipboard]="entry[1]">
                  <mat-icon>content_copy</mat-icon>
              </button>
          </td>
        </tr>
        } @empty {
        <tr>
          <td class="border border-gray-300 p-2">Aucune information technique disponible</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>
